import { DialogActions } from "components/Theme/dialog.tsx";
import type React from "react";
import CancelButton, { type CancelButtonProps } from "./CancelButton.tsx";
import CreateButton, { type CreateButtonProps } from "./CreateButton.tsx";

interface DefaultDialogActionButtonsProps {
  createButton: CreateButtonProps;
  cancelButton: CancelButtonProps;
}

export default function DefaultDialogActionButtons(
  props: DefaultDialogActionButtonsProps,
): React.ReactElement {
  return (
    <DialogActions className={"flex"}>
      <CancelButton {...props.cancelButton} />
      <CreateButton {...props.createButton} />
    </DialogActions>
  );
}
